<script>
import RecycleModal from './RecycleModal.vue'
import axios from 'axios';
import FailModal from './FailModal.vue'
import moment from 'moment'
import ModalConfirm from '../../ModalConfirm.vue';
import MoveToLoadingOfferModal from './MoveToLoadingOffer.vue';

export default {
    components: {
        RecycleModal,
        FailModal,
        ModalConfirm,
        MoveToLoadingOfferModal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        logs: {
            type: Object,
            required: false
        },
        atsType: {
            type: String,
            required: true
        },
        panelInterviewLogs: {
            type: Object,
            required: false
        }
    },

    data() {
        return {
            average: 0,
            fail_reason: '',
            fileNames: {},
            passBtnDisabled: false,
            background_verification_status: this.jobApplication.background_verification_status,
            backgroundVerificationResults: []
        }
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        updateResultStatus(id, index) {
            const currentResult = this.jobApplication.background_verification_results[index];

            const formData = {
                id: id,
                result: currentResult.result
            }

            axios.post(`/ajax/background-verification/update-status/${id}`, formData).then(function (response) {
                if (response.statusText !== "OK") {
                    throw new Error();
                } else {
                    window.location.reload()
                }
            });
        },
        async uploadAttachment(id, event) {
            const target = event.target;
            if (target.files === null) {
                return;
            }

            target.disabled = true;

            const attachment = target.files[0]

            this.fileNames[id] = attachment.name
            console.log(this.fileNames)
            let formData = new FormData();
            formData.append("result_file", attachment);
            formData.append("id", id);
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        submitBackgroundVerification() {
            this.$nextTick(() => {
                this.$refs.submitBackgroundVerificationButton.click();
            });
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.background_verification_status = 'passed';
        },
        convertDate(date, format = 'YYYY-MM-DD HH:mm') {
            return moment.parseZone(date).format(format)
        },
        mappingResult(){
            if (this.jobApplication.job.requisition.person_specification.ats_type == 'agent' && this.jobApplication.panel_interview_status !== 'passed') {
                return [];
            }

            if (this.jobApplication.job.requisition.person_specification.ats_type != 'agent' && this.jobApplication.first_interview_status !== 'passed') {
                return [];
            }

            this.backgroundVerificationResults = [];
            //mapping background verification results to background verification specs
            const backgroundVerificationSpecs = this.jobApplication.job.requisition.person_specification.background_verification_specs;
            for(let indexSpec in backgroundVerificationSpecs) {
                const spec = backgroundVerificationSpecs[indexSpec];
                const result = this.jobApplication.background_verification_results.find((result) => {
                    return result.background_verification_spec_id === spec.id;
                });

                this.backgroundVerificationResults.push({
                    result: result,
                    background_verification_spec: spec
                });
            }
        },
        isMatricCert(checkId) {
            return [55, 56, 57, 132, 6, 7, 98].includes(parseInt(checkId))
        },
        passSendToSage() {
            this.background_verification_status = 'passed';
            this.send_to_sage = 'yes';

            let btn = this.$refs['passButton'];
            setTimeout(function() {
                btn.click();
            }, 200);
        },
        passOnly() {
            this.background_verification_status = 'passed';
            this.send_to_sage = '';

            let btn = this.$refs['passButton'];
            setTimeout(function() {
                btn.click();
            }, 200);
        }
    },
    computed: {
        permissionGrantedDate() {
            return moment(this.jobApplication.permission_granted).format('DD/MM/YY hh:mm')
        },
        disabledSubmitBackgroundVerification() {
            if (this.atsType === 'leadership_and_support') {
                return (this.jobApplication.skills_assessment_status === null || this.jobApplication.skills_assessment_status === '')
            }

            return (this.jobApplication.panel_interview_status === null || this.jobApplication.panel_interview_status === '')
        },
        matricCertNumber() {
            const qualification = this.jobApplication.user.user_detail.qualifications.find(function (data) {
                return data.highest_edu_level == 1;
            });

            if (qualification) {
                return qualification.qualification_documents.length > 0;
            }

            return null
        },
        iFactsMatricCheck() {
            if (!this.jobApplication.job.requisition.person_specification.background_verification_specs) {
                return null;
            }

            const _$this = this;
            return this.jobApplication.job.requisition.person_specification.background_verification_specs.filter(function (data) {
                if (!data.ifacts_check) {
                    return null;
                }
                return _$this.isMatricCert(data.ifacts_check.check_id);
            });
        },
        modalMessage() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber
            ) {
                return 'This person you are trying to send to iFacts does not have a Matric Certificate to check. Are you sure you want to send all remaining checks?'
            }else if (this.iFactsMatricCheck && this.matricCertNumber && this.jobApplication.background_verification_results.length > 0) {
                return 'You will submit to iFacts for a Matric Certificate check on this candidate. Are you sure you want to send this remaining check?'
            }
            return 'Are you sure ? This action will submit background verification checks'
        },
        excludedIds() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber &&
                this.jobApplication.background_verification_results.length <= 0
            ) {
                return this.iFactsMatricCheck.map(function (item) {
                    return item.id;
                }).join(',')
            }

            if (
                this.iFactsMatricCheck &&
                this.matricCertNumber &&
                (
                    this.jobApplication.background_verification_results.length !==
                    this.jobApplication.job.requisition.person_specification.background_verification_specs.length
                )
            ) {
                return this.jobApplication.background_verification_results.map(function (item) {
                    return item.background_verification_spec_id
                })
                    .join(',')
            }
        }
    },
    mounted() {
        if (this.jobApplication.background_verification_status == 'passed') {
            this.passBtnDisabled = true;
        }
        this.mappingResult()
    },
    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.background_verification_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    }
}
</script>

<template>
    <div class="background-verification p-4" v-if="jobApplication.permission_granted">
        <form method="post" v-on:submit="disablePassBtn">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="background_verification_status" :value="background_verification_status">
            <input type="hidden" name="send_to_sage" :value="send_to_sage" />

            <div class="mb-3">

                <div v-if="jobApplication.is_background_check_manual && jobApplication.panel_interview_status === 'passed'">
                    <span v-if="panelInterviewLogs !== null && panelInterviewLogs !== ''">
                        Manual Passed By: {{ panelInterviewLogs.user.first_name }} {{ panelInterviewLogs.user.last_name }} - {{ convertDate(panelInterviewLogs.created, 'YYYY-MM-DD HH:mm') }}
                    </span>
                </div>

                <div>Candidate granted permission for background checks: {{ permissionGrantedDate }}</div>
                <div v-if="jobApplication.background_verification_enquiries" class="font-weight-bold mt-3">
                    <div v-for="(ifact_enquiry, index) in jobApplication.background_verification_enquiries" :key="index">
                        <span>Enquiry number: {{ ifact_enquiry.ifacts_enquiry_id }} - </span>
                        <span v-if="ifact_enquiry.attachment_path_cdn">Ifact Check Result: <a class="btn btn-sm btn-success" target="_blank" :href="ifact_enquiry.attachment_path_cdn">Download</a></span>
                        <span v-else>Ifact check is in progress</span>
                    </div>
                </div>

                <div class="text-danger" v-if="
                    iFactsMatricCheck &&
                    jobApplication.background_verification_results.length !== jobApplication.job.requisition.person_specification.background_verification_specs.length &&
                    jobApplication.background_verification_results.length > 0
                ">
                    This candidate has {{ iFactsMatricCheck.length }} left background verification to check.
                    <div v-for="check in iFactsMatricCheck" :key="check">{{ check.title }}</div>
                </div>
            </div>
            <div v-for="(backgroundVerificationResult, i) in backgroundVerificationResults"
                class="bg-white rounded mb-4" :key="i">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-7">
                        <div style="width: 90%">
                            <strong>Check {{ i + 1 }}:</strong>
                            <br>
                            <div style="background-color: #eff3f8; padding:20px; border-radius: 2px" class="mt-2">
                                <div v-if="backgroundVerificationResult.background_verification_spec.method === 'ifacts'">
                                    <div>
                                        <strong>
                                            {{ backgroundVerificationResult.background_verification_spec.title }}
                                        </strong>
                                        <br />
                                        <span style="color:#979797; font-size: .9rem">
                                            {{ backgroundVerificationResult.background_verification_spec.method }}
                                        </span>
                                    </div>
                                    <div class="bg-white p-3 mt-2">
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell auto">
                                                <label>Result:</label>
                                            </div>
                                            <div class="cell auto" v-if="!backgroundVerificationResult.result">
                                                <div class="cell shrink text-right" v-if="jobApplication.permission_granted && isMatricCert(backgroundVerificationResult.background_verification_spec.ifacts_check.check_id)">
                                                    <button class="button primary mt-0 right" type="button" @click="toggleModal('confirmModal')" :disabled="!matricCertNumber">
                                                        SEND IFACT CHECK
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="backgroundVerificationResult.result">{{ backgroundVerificationResult.result.result_text }}</div>
                                    </div>
                                    <div class="bg-white p-3 my-3">
                                        <label>Attachment:</label>

                                        <div  v-if="backgroundVerificationResult.result">
                                            <div v-if="backgroundVerificationResult.result.result_file !== null && backgroundVerificationResult.result.result_file !== ''">
                                                <a
                                                    target="_blank"
                                                    :href="`${backgroundVerificationResult.result.result_file_cdn}`"
                                                    class="mb-3"
                                                >
                                                    {{ sliceString(backgroundVerificationResult.result.result_file) }}
                                                </a><br/>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="backgroundVerificationResult.result">
                                        <p>Manual pass/ fail override:</p>
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell small-5">
                                                <select
                                                    class="border-0" @change="updateResultStatus(backgroundVerificationResult.result.id, i)"
                                                    v-model="backgroundVerificationResult.result.result"
                                                >
                                                    <option></option>
                                                    <option value="pass">Pass</option>
                                                    <option value="fail">Fail</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div>
                                        <strong>
                                            {{ backgroundVerificationResult.background_verification_spec.title }}
                                        </strong>
                                        <br />
                                        <span style="color:#979797; font-size: .9rem">
                                            {{ backgroundVerificationResult.background_verification_spec.method }}
                                        </span>
                                    </div>
                                    <div class="bg-white p-3 mt-2" v-if="backgroundVerificationResult.result">
                                        <label>Result:</label>
                                        <div>{{ backgroundVerificationResult.result.result_text }}</div>
                                    </div>
                                    <div class="my-3" v-if="backgroundVerificationResult.result">
                                        <label>Attachment:</label>

                                        <div v-if="backgroundVerificationResult.result.result_file !== null && backgroundVerificationResult.result.result_file !== ''">
                                            <a
                                                target="_blank"
                                                :href="`${backgroundVerificationResult.result.result_file_cdn}`"
                                                class="mb-3"
                                            >
                                                {{ sliceString(backgroundVerificationResult.result.result_file) }}
                                            </a><br/>
                                        </div>

                                        <div class="bg-white p-4 d-flex justify-content-between" @click="$refs.backgroundVerifUpload[0].click()" style="cursor: pointer">
                                            <span class="text-muted">Upload File(s)</span>
                                            <i class="fa-solid fa-upload" style="color: #217FBD"></i>
                                            <input ref="backgroundVerifUpload" @change="uploadAttachment(backgroundVerificationResult.result.id, $event)" type="file" class="d-none" />
                                        </div>
                                    </div>
                                    <div v-if="backgroundVerificationResult.result">
                                        <p>Manual pass/ fail override:</p>
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell small-5">
                                                <select
                                                    class="border-0"
                                                    @change="updateResultStatus(backgroundVerificationResult.result.id, i)"
                                                    v-model="backgroundVerificationResult.result.result"
                                                >
                                                    <option></option>
                                                    <option value="pass">Pass</option>
                                                    <option value="fail">Fail</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cell small-5">
                        <label>Notes:</label>
                        <p>{{ backgroundVerificationResult.background_verification_spec.notes }}</p>
                    </div>
                </div>
            </div>

            <hr style="max-width: unset;" />
            <strong>Final Status: </strong> <span class="">{{ jobApplication.background_verification_status }}</span>
            <span v-if="logs !== null && logs !== ''">
                &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created) }})
            </span>
            <hr style="max-width: unset;" />

            <div class="grid-x grid-padding-x mt-4">
                <div v-if="this.jobApplication.job.requisition.person_specification.ats_type == 'agent'">
                    <button class="d-none"
                        value="pass"
                        ref="passButton"
                        type="submit"
                    ></button>

                    <button
                        type="button"
                        class="button px-5"
                        :disabled="passBtnDisabled"
                        @click="toggleModal('moveToLoadingOfferModal')"
                    >Pass</button>
                </div>
                <div v-else>
                    <button class="d-none"
                        value="pass"
                        ref="passButton"
                        name="background_verification_status"
                    ></button>

                    <button
                        class="button px-5"
                        type="button"
                        @click="passOnly"
                    >Pass</button>
                </div>

                <div class="cell shrink">
                    <button class="d-none" value="failed" ref="failedButton" name="background_verification_status"></button>
                    <button
                        class="button alert px-5"
                        type="button"
                        name="background_verification_status"
                        value="failed"
                        @click="toggleModal('failModal')"
                    >Fail</button>
                </div>
                <div>
                    <button class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                </div>
                <button class="d-none" name="submit_background_verification" value="submit" ref="submitBackgroundVerificationButton"></button>
                <div class="d-none cell shrink" v-if="jobApplication.permission_granted && jobApplication.background_verification_results.length === 0">
                    <button class="button primary px-5" type="button" @click="toggleModal('confirmModal')" :disabled="disabledSubmitBackgroundVerification">
                        Submit Background Verification
                    </button>
                </div>
                <input type="hidden" name="exclude_matric_check" :value="excludedIds"/>
            </div>
        </form>
        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
        <modal-confirm ref="confirmModal" :message="modalMessage" @confirmed="submitBackgroundVerification"/>
        <move-to-loading-offer-modal 
            ref="moveToLoadingOfferModal"
            @passSendToSage="passSendToSage"
            @passOnly="passOnly"
            :enable-send-to-sage="(jobApplication.job.requisition.job_profile.external_requisition_number && jobApplication.job.requisition.job_profile.sage_job_requisition_id && jobApplication.job.requisition.job_profile.external_requisition_number !== '' && jobApplication.job.requisition.job_profile.sage_job_requisition_id !== '') ? true : false"

        />
    </div>
    <div v-else class="text-red">
        PERMISSION NOT GRANTED
    </div>
</template>